import './polyfills' // Must be first — sets up Buffer global before AWS SDK modules load

//these imports replace the stylesheet ref's in index.html
// <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900">
//   <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Material+Icons">
import './static/css/google.materialicons.css'
import './static/css/google.roboto.css'

import { createApp } from 'vue'

import store from './store'
import vuetify from './plugins/vuetify';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

// eslint-disable-next-line no-console
console.log(`version=${process.env.VUE_APP_VERSION}`)

import App from './App.vue'

import Auth from "@aws-amplify/auth";
import trupledevawsconfig from "./amplify/truple/dev/aws-exports";
import trupleprodawsconfig from "./amplify/truple/prod/aws-exports";
import badevawsconfig from "./amplify/bestaccountability/dev/aws-exports";
import baprodawsconfig from "./amplify/bestaccountability/prod/aws-exports";

let cfg
if(process.env.VUE_APP_PRODUCT === 'bestaccountability') {
  cfg = process.env.VUE_APP_AWS_ENV === 'prod' ? baprodawsconfig : badevawsconfig
} else {
  cfg = process.env.VUE_APP_AWS_ENV === 'prod' ? trupleprodawsconfig : trupledevawsconfig
}

if(process.env.VUE_APP_ENV_AMPLIFY_CLIENT_ID_OVERRIDE) {
  // eslint-disable-next-line no-console
  console.log('process.env.VUE_APP_ENV_AMPLIFY_CLIENT_ID_OVERRIDE')
}

if(process.env.VUE_APP_LOCAL === "true") {
  // eslint-disable-next-line no-console
  console.log('process.env.VUE_APP_LOCAL ' + process.env.VUE_APP_LOCAL)
  cfg.Auth.oauth.redirectSignIn = 'http://localhost:8080/'
  cfg.Auth.oauth.redirectSignOut = 'http://localhost:8080/'
}

if(process.env.VUE_APP_AWS_ENV === 'prod' && localStorage.getItem('debug') !== 'true') {
  // eslint-disable-next-line no-console
  console.log = () => {}
}

Auth.configure(cfg)

import VueChartkick from 'vue-chartkick'
import 'chartkick/chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Chart } from 'chart.js'
Chart.register(ChartDataLabels)
Chart.defaults.plugins.datalabels = Chart.defaults.plugins.datalabels || {}
Chart.defaults.plugins.datalabels.anchor = 'end'
Chart.defaults.plugins.datalabels.clamp = true
Chart.defaults.plugins.datalabels.align = 'end'

import router from './lib/router'

import auth from './lib/auth'
import api from './lib/api'

// Load Segment analytics (was previously in index.html)
if (window.analytics && process.env.VUE_APP_SEGMENT_KEY) {
  window.analytics.load(process.env.VUE_APP_SEGMENT_KEY)
}

const app = createApp(App)

app.use(store)
app.use(router)
app.use(vuetify)
app.use(VueSweetalert2, {
  confirmButtonColor: process.env.VUE_APP_COLOR_PRIMARY,
  cancelButtonColor: process.env.VUE_APP_COLOR_SECONDARY,
})
app.use(VueChartkick)
app.config.globalProperties.auth = auth
app.config.globalProperties.api = api

app.config.devtools = process.env.VUE_APP_AWS_ENV === 'dev'

app.mount('#app')
